import { DesignLanguage, Message, RegularIconNames, useDesignLanguagePerClass, useIsDesignLanguage } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useGiftCardPromoTrackingProperties, useGiftCardPromoUnavailablePercentOff, useIsGiftCardPromoUnavailable } from '../../state'
import { TrackingEvent } from '../../model/monitoring'
import { useLogGiftCardPromoViewOnce } from '../GiftCardPromoTracking'
import { useTranslation } from '../../utils/convergence'
import styles from './style.module.css'

export const GIFT_CARD_PROMO_UNAVAILABLE_MESSAGE_NAMESPACE = 'gift-card-promo-unavailable'

export const GiftCardPromoUnavailableMessage: FunctionComponent = () => {
  const { t } = useTranslation(['summary'])
  const isPromoUnavailable = useIsGiftCardPromoUnavailable()
  const percentOff = useGiftCardPromoUnavailablePercentOff()
  const trackingProperties = useGiftCardPromoTrackingProperties()
  const designLanguageClass = useDesignLanguagePerClass(styles)
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const iconName: RegularIconNames = isArcadeDesignLanguage ? 'AlertFill' : 'Info'
  useLogGiftCardPromoViewOnce(TrackingEvent.VIEWED_GIFT_CARD_PROMOTION_UNAVAILABLE_MESSAGE, isPromoUnavailable ? trackingProperties : null)

  if (!isPromoUnavailable) {
    return null
  }

  const description =
    percentOff === null
      ? t('summary:giftCardPromotion.unavailableInlineGeneric', { context: 'default' })
      : t('summary:giftCardPromotion.unavailableInline', { context: 'default', percentOff })

  return (
    <div className={designLanguageClass.wrapper} data-testid={GIFT_CARD_PROMO_UNAVAILABLE_MESSAGE_NAMESPACE}>
      <Message iconName={iconName} kind='Basic' description={description} testNameSpace={GIFT_CARD_PROMO_UNAVAILABLE_MESSAGE_NAMESPACE} />
    </div>
  )
}
